export class TeacherFileDTO {
  icon_image_client_url = '';
  icon_image_file?: any;

  movie_client_url = '';
  movie_file?: any;
}
